import React from 'react'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import { makeStyles } from '@material-ui/core/styles'
import Divider from '@material-ui/core/Divider'
import ListItemText from '@material-ui/core/ListItemText'
import CircularProgress from '@material-ui/core/CircularProgress'
import Badge from '@material-ui/core/Badge'
import * as textUtils from '../utils/text'
import MessageError from './MessageError'
import MessageDialog from './MessageDialog'
import MessageDialogMongo from './MessageDialogMongo'
import MessagePlaceholder from './MessagePlaceholder'
import { messagesMutations,messagesMongoMutations } from '../graphql/mutations'
import { messagesQueries,messagesMongoQueries } from '../graphql/queries' 
import { Query, Mutation } from 'react-apollo'
import { useQuery } from '@apollo/react-hooks'

const useStyles = makeStyles(theme => ({
	messageBadge: {
		top: 0
	},
	progress: {
		position: 'absolute',
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		margin: 'auto'
	},
	listItem: {
    maxHeight: 100,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
  }
}))

const MessageList = () => {
  const classes = useStyles()
  const [dialogMongo, setOpenDialogMongo] = React.useState({ open: false, message: {} })
  const [dialog, setOpenDialog] = React.useState({ open: false, message: {} })
  const { data:dataMongo } = useQuery(messagesMongoQueries.GET_MESSAGES_MONGO)
  const [msgSSO, setMsgSSO] =React.useState(false)
  const [msgMongo , setMsgMongo] =React.useState([])

  const handleMessage = (message) => {
    setOpenDialog({
      open: !dialog.open,
      message: message
    })
  }
  const handleMessageMongo = (message) => {
    setOpenDialogMongo({
      open: !dialogMongo.open,
      message: message
    })
  }

	return (
		<>
			<List style={{ height: 350, maxHeight: 450 }}>
				<Query query={messagesQueries.GET_MESSAGES}>
					{({ loading, error, data, refetch }) => {
						if (loading) return <CircularProgress className={classes.progress} size={30} />
						if (error) return <MessageError  refresh={refetch}/>
					
						const { messages = [] } = data	
							
						
						if (!messages.length && !dataMongo.messagesMongo.length ) {
							return (
								<MessagePlaceholder />
							)
							
						}else{						
						
						if (messages.length){
							setMsgSSO('1')
						}

						return (
							<React.Fragment>
								{messages.map((message, index) => (
									<div key={message.id} className={classes.listItem}>
										<ListItem  onClick={() => handleMessage(message)}>
											<ListItemText
												primary={(
													<div dangerouslySetInnerHTML={{ __html: message.titulo }} />
												)}
												secondary={
													<div dangerouslySetInnerHTML={{ 
														__html: textUtils.truncateEllipsis(
																(message.mensage || '').replace(/<[^>]*>/gi, ''),
																70,
																false)
															}} 
													/>
												}
											/>
											<Badge 
												className={classes.messageBadge}
												badgeContent=""
												variant="dot" 
												overlap="circle"
												color="secondary"
												invisible={message.viewed}
											>
											</Badge>
										</ListItem>
										<Divider component="li"  className={classes.listItem}/>
									</div>
								))}
							</React.Fragment>
						)
					}}}
				</Query>	

				<Query query={messagesMongoQueries.GET_MESSAGES_MONGO}>
					{({ loading:loadingMongo, error:errorMongo, data:dataMongo, refetch:refetchMongo }) => {
						if (loadingMongo) return <CircularProgress className={classes.progress} size={30} />
						if (errorMongo) return <MessageError  refresh={refetchMongo}/>
					
						
						if(dataMongo.messagesMongo.length){
							setMsgMongo(dataMongo.messagesMongo)
						return (
							<React.Fragment>
								{msgMongo.map((message, index) => (
									<div key={message._id} className={classes.listItem}>
										<ListItem  onClick={() => handleMessageMongo(message)}>
											<ListItemText
												primary={(
													<div dangerouslySetInnerHTML={{ __html: message.titulo }} />
												)}
												secondary={
													<div dangerouslySetInnerHTML={{ 
														__html: textUtils.truncateEllipsis(
																(message.mensagem || '').replace(/<[^>]*>/gi, ''),
																70,
																false)
															}} 
													/>
												}
											/>
											<Badge 
												className={classes.messageBadge}
												badgeContent=""
												variant="dot" 
												overlap="circle"
												color="secondary"
												invisible={message.visualizado}
											>
											</Badge>
										</ListItem>
										<Divider component="li"  className={classes.listItem}/>
									</div>
								))}

								

							</React.Fragment>
						)
						}else{
							return (
								<></>
							)
						}
					}}
				</Query>
							
			</List>
			
			{msgSSO &&(
			<Mutation
				mutation={messagesMutations.MARK_AS_READ}
				update={(cache, { data }) => {
					if (!data.markMessageAsRead) return
					const { messages } = cache.readQuery({
						query: messagesQueries.GET_MESSAGES
					})
					cache.writeQuery({
						query: messagesQueries.GET_MESSAGES,
						data: {
							messages: messages.map(message => {
								if (message.id === dialog.message.id) return { ...message, viewed: true }
								return message
							})
						}
					})
				}}
			>
				{(markMessageAsRead, { data }) => {
					return (
						<MessageDialog							
							open={dialog.open}
							message={dialog.message}
							onOpen={() => {
								markMessageAsRead({
									variables: {
										id: dialog.message.id
									}
								})
							}}
							onClose={() => {
								handleMessage(dialog.message)
							}}
						/>
					)
				}}
			</Mutation>
			)}

			{dataMongo && (
			<Mutation
			
				mutation={messagesMongoMutations.MARK_AS_READ_MONGO}
				update={(cache, { data }) => {
					if (!data.markMessageMongoAsRead) return
					const { messagesMongoMutations } = cache.readQuery({
						query: messagesMongoQueries.GET_MESSAGES_MONGO
					})
					cache.writeQuery({
						query: messagesMongoQueries.GET_MESSAGES_MONGO,
						data: {
							messages: messagesMongoMutations.map(message => {
								if (message.id === dialogMongo.message._id) return { ...message, visualizado:true }
								return message
							})
						}
					})
				}}
			>
				{(markMessageMongoAsRead, { data }) => {
					return (
						<MessageDialogMongo
							setMessage= {(id)=>{
								//atualiza lista de mensagens removendo o item apagado
								for(let i=0; i<msgMongo.length; i++){
									if(msgMongo[i]._id == id){
										setMsgMongo(msgMongo.splice(i, 1))
										return
									}
								}	
							}}
							open={dialogMongo.open}
							message={dialogMongo.message}
							onOpen={() => {
								markMessageMongoAsRead({
									variables: {
										id: dialogMongo.message._id
									}
								})
							}}
							onClose={() => {
								handleMessageMongo(dialogMongo.message)
							}}
						/>
					)
				}}
			</Mutation>
			)}



		</>
	)
}

export default MessageList
